// @ts-nocheck



import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ExternalActList, ExternalActForm, ExternalActCard } from './external';
import {
  InternalActList,
  InternalActForm,
  MpzActList,
  MpzActForm } from
'./internal';
import { RouteComponent } from '../../lib/routerAdapter';

export { ActInfo } from './external';
export { default as Tabs } from './components/Tabs';


export default () =>
<>
    <Routes>
      <Route index element={<RouteComponent component={ExternalActList} />} />
      <Route path="new" element={<RouteComponent component={ExternalActForm} />} />
      <Route path=":actId/edit" element={<RouteComponent component={ExternalActForm} />} />
      <Route path=":actId" element={<RouteComponent component={ExternalActCard} />} />

      <Route path="internal/mpz" element={<RouteComponent component={MpzActList} />} />
      <Route path="internal/mpz/new/:action" element={<RouteComponent component={MpzActForm} />} />
      <Route path="internal" element={<RouteComponent component={InternalActList} />} />
      <Route path="internal/:actType" element={<RouteComponent component={InternalActList} />} />
      <Route
      path="internal/outsourcing-act/new"
      element={<RouteComponent component={InternalActForm} type="outsourcing-act" />} />

      <Route
      path="internal/outsourcing-act/:id/edit"
      element={<RouteComponent component={InternalActForm} type="outsourcing-act" />} />

      <Route
      path="internal/oils-act/new"
      element={<RouteComponent component={InternalActForm} type="oils-act" />} />

      <Route
      path="internal/fuels-and-oils-act/new"
      element={<RouteComponent component={InternalActForm} type="fuels-and-oils-act" />} />

      <Route
      path="internal/fuels-and-oils-act/:id/edit"
      element={<RouteComponent component={InternalActForm} type="fuels-and-oils-act" />} />

    </Routes>
  </>;
